import axios from 'axios';

async function request(config) {
    const instance = axios.create({
        baseURL: this.$baseurl,
        timeout: 5000,
        headers: {
            "Content-Type": "application/json",
        },
    });

    // 请求拦截
    instance.interceptors.request.use(
        (config) => {
            // 添加Token等处理逻辑
            // console.log(config);
            if (config.url.indexOf("login") < 0) {
                // 非登录接口  添加userId
                let temp = JSON.parse(JSON.stringify(config.data))
                if (temp != null) {
                    let userData = JSON.parse(sessionStorage.getItem("userData"))
                    temp.userId = userData.userId
                    config.data = JSON.stringify(temp)
                }
            }
            return config;
        },
        (error) => {

            return Promise.reject(error);
        }
    );

    // 响应拦截
    instance.interceptors.response.use(
        (response) => {
            //对应的是下方 await instance(config); 的返回值
            return response.data;
        },
        (error) => {
            console.log("请求失败", error);
            return Promise.reject(error);
        }
    );

    try {
        const res = await instance(config);
        switch (res.code) {
            case "200":
                return res.result
                break;

            case "500":
                throw res;
                break;
            case "401":
                window.sessionStorage.removeItem("token");
                this.$router.push("/");
                throw res;
                break;

            default:
                throw res;
                break;
        }
    } catch (error) {
        throw error;
    }
}

export default request;